import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WerkplaatsHero from "@/components/WerkplaatsHero";
import WerkplaatsVideosSection from "@/components/WerkplaatsVideosSection";
import ValuePropositions from "@/components/ValuePropositions";
import WerkplaatsContactSection from "@/components/WerkplaatsContactSection";
import ReviewsCarousel from "@/components/ReviewsCarousel";


function WerkplaatsPage() {
  return (
    <div className="bg-white text-black">
      <Navbar />

      <WerkplaatsHero />

      <WerkplaatsVideosSection />

      <ValuePropositions />

      <WerkplaatsContactSection />

      <ReviewsCarousel />

      <Footer />
    </div>
  );
}

export default WerkplaatsPage; 